module.exports = new __parcel__URL__("platinum3.5d7e469a.png").toString();